/* Arjit4Amply: product-page reviews (sections/matre-reviews.liquid) - the
   mockup's "Showing X of Y reviews" + "Show N more reviews +" button in
   place of Judge.me's page numbers.
   Why: this store has Judge.me's widget revamp on, so the page-number
   script never loads for the embedded (metafield) widget we use - the
   numbers rendered but did nothing. More reviews are fetched from the same
   Judge.me endpoint its own pagination uses (the .jdgm-paginate data-url)
   and appended to the list, 10 at a time as in the mockup (Judge.me's own
   first render of 5 is swapped for the first 10 on load). Judge.me's own header (second "Customer
   Reviews" title + rating) is hidden in matre-reviews.css - our section
   header carries both, as in the mockup. */
(function () {
  /* Each Judge.me review is redrawn as the mockup's .customer-review-entry:
     stars, name + "<product> customer" pill + relative date, title, text.
     The data comes from Judge.me's own markup (rating, author, product,
     timestamp, title, body); its badges/icons/vote rows are dropped. */
  function productLabel(title) {
    if (!title) return '';
    var t = title.toLowerCase();
    if (t.indexOf('night ritual') !== -1 || t.indexOf('starter pack') !== -1) return 'Calm + Deep Sleep';
    return t.replace(/(^|\s)(\S)/g, function (m, s, c) {
      return s + c.toUpperCase();
    });
  }

  function timeAgo(date) {
    var days = Math.floor((Date.now() - date.getTime()) / 86400000);
    function unit(n, word) {
      return n + ' ' + word + (n === 1 ? '' : 's') + ' ago';
    }
    if (days < 1) return 'Today';
    if (days < 30) return unit(days, 'day');
    if (days < 365) return unit(Math.floor(days / 30), 'month');
    return unit(Math.floor(days / 365), 'year');
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function redraw(rev) {
    if (rev.classList.contains('matre-review')) return;
    var rating = rev.querySelector('.jdgm-rev__rating');
    var score = Math.round(parseFloat(rating && rating.getAttribute('data-score')) || 5);
    var author = rev.querySelector('.jdgm-rev__author');
    var time = rev.querySelector('.jdgm-rev__timestamp');
    var title = rev.querySelector('.jdgm-rev__title');
    var body = rev.querySelector('.jdgm-rev__body');
    var pics = rev.querySelector('.jdgm-rev__pics');

    var article = el('article', 'matre-review__entry');
    var stars = el('div', 'matre-review__stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', score + ' out of 5 stars');
    stars.appendChild(document.createTextNode('★'.repeat(score)));
    if (score < 5) stars.appendChild(el('span', 'matre-review__stars-off', '★'.repeat(5 - score)));
    article.appendChild(stars);

    var meta = el('div', 'matre-review__author');
    meta.appendChild(el('strong', '', author ? author.textContent.trim() : 'Anonymous'));
    var label = productLabel(rev.getAttribute('data-product-title'));
    if (label) meta.appendChild(el('span', '', label + ' customer'));
    var iso = time && time.getAttribute('datetime');
    var date = iso ? new Date(iso) : null;
    if (date && !isNaN(date)) {
      var t = el('time', '', timeAgo(date));
      t.setAttribute('datetime', iso);
      t.setAttribute('title', date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }));
      meta.appendChild(t);
    }
    article.appendChild(meta);

    if (title && title.textContent.trim()) article.appendChild(el('h3', '', title.textContent.trim()));
    if (body) {
      var paras = body.querySelectorAll('p');
      var text = paras.length
        ? Array.prototype.map
            .call(paras, function (p) {
              return p.textContent.trim();
            })
            .join('\n\n')
        : body.textContent.trim();
      if (text) article.appendChild(el('p', '', text));
    }
    if (pics) article.appendChild(pics);

    rev.textContent = '';
    rev.appendChild(article);
    rev.classList.add('matre-review');
  }

  function redrawAll(root) {
    root.querySelectorAll('.jdgm-rev').forEach(redraw);
  }

  function setup(section) {
    var widget = section.querySelector('#judgeme_product_reviews');
    var pag = widget && widget.querySelector('.jdgm-paginate');
    var list = widget && widget.querySelector('.jdgm-rev-widg__reviews');
    if (!widget || section.querySelector('.matre-reviews__more')) return;
    // Judge.me has stopped filling the legacy widget metafield (seen live
    // 2026-10-06: empty widget, badge still set) - so build the list here
    // and load every review from its endpoint instead.
    if (!list) {
      list = document.createElement('div');
      list.className = 'jdgm-rev-widg__reviews';
      widget.appendChild(list);
    }
    section.classList.add('matre-reviews--redrawn');
    // Judge.me omits the pager when all reviews fit on one page.
    var endpoint = pag ? pag.getAttribute('data-url') : 'https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true';

    // 10 per step, as the mockup (Judge.me's own setting renders 5).
    var perPage = 10;
    var summary = widget.querySelector('.jdgm-rev-widg');
    var total =
      parseInt(summary && summary.getAttribute('data-number-of-reviews'), 10) ||
      parseInt(widget.getAttribute('data-review-count'), 10) ||
      0;
    var page = 0;
    var grandTotal = total;

    // Filter + sort (the mockup's two icon buttons). Judge.me filters by
    // rating and sorts by date/rating itself; it can't sort by name, so
    // "Reviewer name" loads all of this product's reviews once and sorts here.
    var state = { rating: 'all', sort: 'newest' };
    var SORTS = {
      newest: { sort_by: 'created_at', sort_dir: 'desc' },
      highest: { sort_by: 'rating', sort_dir: 'desc' },
      lowest: { sort_by: 'rating', sort_dir: 'asc' }
    };
    var LABELS = { newest: 'Most recent', highest: 'Highest rating', lowest: 'Lowest rating', name: 'Reviewer name' };
    var byName = null;

    var box = document.createElement('div');
    box.className = 'matre-reviews__more';
    box.innerHTML =
      '<p role="status" aria-live="polite"></p>' +
      '<button type="button"><span data-label></span> <span aria-hidden="true">+</span></button>';
    widget.parentNode.insertBefore(box, widget.nextSibling);
    section.classList.add('matre-reviews--more');

    var status = box.querySelector('p');
    var button = box.querySelector('button');
    var label = box.querySelector('[data-label]');

    function shown() {
      return list.querySelectorAll('.jdgm-rev').length;
    }

    function update() {
      var count = shown();
      if (count > total) total = count;
      var filtered = state.rating !== 'all';
      status.textContent =
        count || !filtered ? 'Showing ' + count + ' of ' + total + (total === 1 ? ' review' : ' reviews') : 'No reviews match this filter.';
      var next = Math.min(perPage, total - count);
      label.textContent = 'Show ' + next + ' more review' + (next === 1 ? '' : 's');
      button.hidden = next <= 0;
      box.hidden = !grandTotal;
    }

    function clearList() {
      list.querySelectorAll('.jdgm-rev').forEach(function (rev) {
        rev.remove();
      });
    }

    function append(reviews, focusFirst) {
      Array.prototype.forEach.call(reviews, function (rev) {
        list.appendChild(rev);
      });
      redrawAll(list);
      if (focusFirst && reviews[0]) {
        reviews[0].setAttribute('tabindex', '-1');
        reviews[0].focus({ preventScroll: true });
      }
    }

    // Bumped on every fresh load; replies to an older load are dropped, so a
    // quick filter/sort change can't be overwritten by a slower response.
    var token = 0;

    function request(pageNo, size, done, tries, mine) {
      if (mine == null) mine = token;
      if (!window.jdgm || !jdgm.shopParams) {
        // Judge.me's script loads async; wait for it (up to ~10s).
        if ((tries || 0) < 40) {
          setTimeout(function () {
            request(pageNo, size, done, (tries || 0) + 1, mine);
          }, 250);
        }
        return;
      }
      var params = jdgm.shopParams();
      params.product_id = widget.getAttribute('data-id');
      params.page = pageNo;
      params.per_page = size;
      if (state.rating !== 'all') params.filter_rating = state.rating;
      var sort = SORTS[state.sort];
      if (sort) {
        params.sort_by = sort.sort_by;
        params.sort_dir = sort.sort_dir;
      }
      var url =
        endpoint +
        (endpoint.indexOf('?') === -1 ? '?' : '&') +
        Object.keys(params)
          .map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
          })
          .join('&');

      button.disabled = true;
      fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (mine !== token) return;
          var temp = document.createElement('div');
          temp.innerHTML = data.html || '';
          total = parseInt(data.total_count, 10) || 0;
          done(temp.querySelectorAll('.jdgm-rev'));
          update();
        })
        .catch(function () {
          status.textContent = 'Reviews could not be loaded. Please try again.';
        })
        .then(function () {
          button.disabled = false;
        });
    }

    // fresh = true starts the list again (first load, or a new filter/sort).
    function load(fresh) {
      if (fresh) {
        page = 0;
        byName = null;
        token += 1;
      }
      if (state.sort === 'name') {
        var reveal = function () {
          var count = fresh ? 0 : shown();
          if (fresh) clearList();
          append(byName.slice(count, count + perPage), !fresh);
          total = byName.length;
          update();
        };
        if (byName) return reveal();
        // Judge.me returns at most 30 per request, so collect page by page.
        var collected = [];
        var mine = token;
        var fetchAll = function (pageNo) {
          if (mine !== token) return;
          request(pageNo, 30, function (reviews) {
            collected = collected.concat(Array.prototype.slice.call(reviews));
            if (reviews.length && collected.length < total) return fetchAll(pageNo + 1);
            byName = collected.sort(function (a, b) {
              var an = (a.querySelector('.jdgm-rev__author') || {}).textContent || '';
              var bn = (b.querySelector('.jdgm-rev__author') || {}).textContent || '';
              return an.trim().localeCompare(bn.trim());
            });
            reveal();
          }, 0, mine);
        };
        return fetchAll(1);
      }
      request(page + 1, perPage, function (reviews) {
        if (fresh) clearList();
        append(reviews, !fresh);
        page += 1;
      });
    }

    button.addEventListener('click', function () {
      load(false);
    });

    // Controls (markup in sections/matre-reviews.liquid).
    var selection = section.querySelector('[data-review-selection]');
    var reset = section.querySelector('[data-clear-review-filter]');
    var toggles = section.querySelectorAll('[data-review-toggle]');

    function closeAll(except) {
      toggles.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        document.getElementById(t.getAttribute('aria-controls')).hidden = true;
      });
    }

    function applyState() {
      var ratingLabel = state.rating === 'all' ? 'All ratings' : state.rating + (state.rating === '1' ? ' star' : ' stars');
      if (selection) selection.textContent = ratingLabel + ' · ' + LABELS[state.sort];
      var changed = state.rating !== 'all' || state.sort !== 'newest';
      if (reset) reset.hidden = !changed;
      toggles.forEach(function (t) {
        var key = t.getAttribute('data-review-toggle');
        t.classList.toggle('is-active', key === 'rating' ? state.rating !== 'all' : state.sort !== 'newest');
      });
      load(true);
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') !== 'true';
        closeAll(t);
        t.setAttribute('aria-expanded', String(open));
        document.getElementById(t.getAttribute('aria-controls')).hidden = !open;
      });
    });

    section.querySelectorAll('input[name="review-rating"], input[name="review-sort"]').forEach(function (input) {
      input.addEventListener('change', function () {
        state[input.name === 'review-rating' ? 'rating' : 'sort'] = input.value;
        closeAll();
        applyState();
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        state = { rating: 'all', sort: 'newest' };
        section.querySelector('input[name="review-rating"][value="all"]').checked = true;
        section.querySelector('input[name="review-sort"][value="newest"]').checked = true;
        applyState();
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.matre-reviews__control')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = section.querySelector('[data-review-toggle][aria-expanded="true"]');
      if (open) {
        closeAll();
        open.focus();
      }
    });

    redrawAll(list);
    update();
    if (shown() < perPage && total > shown()) load(true);
    else page = 1;
  }

  function init() {
    document.querySelectorAll('.matre-reviews').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
